import { Accordion, Heading } from '@zillow/constellation-10';

import { VIEW_TYPE } from './constants';

import type React from 'react';

type WizardTipProps = {
  header?: string | null;
  headerLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  viewType: string;
  children: React.ReactNode;
};

const WizardTip = ({ header = null, headerLevel, viewType = VIEW_TYPE.ACCORDION, children }: WizardTipProps) => {
  const renderAccordion = () => {
    return (
      <Accordion.Root>
        <Accordion.Item value="wizard-tip">
          <Accordion.Header>
            <Heading level={headerLevel ?? 5} textStyle="heading-xs">
              {header}
            </Heading>
          </Accordion.Header>
          <Accordion.Panel>{children}</Accordion.Panel>
        </Accordion.Item>
      </Accordion.Root>
    );
  };

  const renderCard = () => {
    return <>{children}</>;
  };

  return <div data-testid="WizardTip">{viewType === VIEW_TYPE.ACCORDION ? renderAccordion() : renderCard()}</div>;
};

export { WizardTip };
